module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("‘O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("F COURSE")])]), _vm._v(" I don’t want to go to bed with you!’ Lydia Kelso said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe Jordan stared at the woman who had just rejected his offer with such stinging contempt, and he registered mental surprise tinged with amusement. Surprise because Lydia Kelso was as different from her sister as chalk from cheese…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had an unruly mane of sun-streaked dark fair hair that looked as if she didn’t bother to torture it into any kind of style. Her skin was smooth and her eyes a deep velvety blue. Whilst she didn’t have immediately turn-your-head kind of looks, that lovely skin, the delicately cut yet severe pair of lips, as well as her stunning eyes, redeemed her to a rather unusual attractiveness. She wore no make-up at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her neck was long and elegant—so was the rest of her: tall and almost boyishly rangy beneath a pinstriped navy trouser suit she wore with black leather loafers. Her shoulders were straight and her hands were narrow yet capable-looking, with short, unpainted nails, and she wore a man’s signet ring on the little finger of her left hand and a man’s watch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Whereas her sister Daisy was drop-dead gorgeous, with dark hair, true violet eyes and a sensational figure…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged, raised an ironic eyebrow at Lydia Kelso, and murmured, ‘I asked because that was the proposition your sister put to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(" when we first met. I thought it might run in the family.’")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You should never generalise about people, even when they come from the same family, Mr Jordan,’ she said coldly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Does that mean you don’t approve of your own sister?’ he asked wryly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia took a breath and subsided somewhat. Then she moved her hands and decided to be honest. ‘I don’t approve of you,’ she said flatly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We’ve only just met,’ he pointed out, with open amusement in his eyes now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Your reputation precedes you, however, so—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘All right.’ He sat up straighter and reached for his pen. ‘Tell me exactly what you know about me, Lydia Kelso. We may then be able to sort the wheat from the chaff.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia looked around Joe Jordan’s colourful studio and reflected that she could have been outmanoeuvred. At the same time she took in the posters on the wall, the books and magazines overflowing from a whole wall of honey pine bookshelves, the polished timber floor with a slightly ruckled rug in jewel-bright ruby swirls on a yellow background. There were two computers on the table behind him, an easel, a skylight above, and a particularly healthy Kentia palm flourishing in a wicker basket in one corner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then she looked back at him across the wide expanse of his untidy desktop, saw the challenge in his eyes and stiffened her spine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All the same, it took her a few moments to compose her mental processes. Because it had been one thing to think dark thoughts about this man in his absence, but being confronted by him, and suddenly able to see what Daisy had obviously seen in him, made it a slightly different matter.")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wasn’t, as she’d expected, to-die-for handsome. On first impressions, that was. She found herself amending the thought. He had thick, straight sandy-brown hair, hazel eyes, a smattering of freckles, and golden hairs glinted on his arms beneath the rolled up sleeves of his khaki bush shirt as a mote of sunlight came in through the skylight. He wore his bush shirt with blue jeans and brown desert boots.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So what was it? Well, he was tall enough—tall enough even for her. Lean, yes, but with wide shoulders, well-knit…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A smile touched her mouth as she wondered exactly what that meant. If it meant all in proportion, with a well-balanced look and the hint of smooth, easy strength beneath his outline, that was exactly the impression Joe Jordan gave. But he was also—interesting, she decided. In a way that was hard to define. You couldn’t help gaining the impression that here was a man it could be exciting to know, especially if you were a woman…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head, reminded herself of his offer to take her to bed although they’d only just met—her blue eyes blazed at the memory—and said, ‘We all know how clever you are, Mr. Jordan. One of the better known cartoonists in the country, but—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why would you hold that against me, assuming it’s true?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Because you have the ability to make people look stupid?’ she countered sweetly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Only when they deserve it,’ he responded mildly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah, but who’s to say your judgement of whether they deserve it or not is always accurate?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe Jordan frowned and sat forward. ‘Have I offended someone you know?’")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No. But you can’t deny it would be possible.’ Lydia gazed at him seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shoved a hand through his brown hair, leaving it standing up in spikes. ‘And that’s cause to disapprove of me in regard to your sister?’ he queried sardonically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s cause for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(" to have reservations about you, Mr Jordan,’ Lydia said precisely. ‘It’s your playboy reputation I fear in regard to my sister. Can you deny that you’re often seen escorting beautiful women around?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Lydia, you wouldn’t be a tad jealous of your very lovely and feminine sister, by any chance?’ he asked smoothly. ‘This—’ he gestured towards her, managing to convey that she wasn’t particularly feminine ‘—has the taint of sour grapes about it, if you’ll forgive me for saying so.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia smiled with genuine amusement. ‘Not in the slightest, Joe! I hope that doesn’t disappoint you. But the fact of the matter is, my sister has plans that you may be unaware of, plans that might not feature on your agenda at all.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Such as marriage plans,’ he said wearily. ‘Look, I can—’ But he stopped at the sudden look of searing contempt in Lydia’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You can—take care of yourself?’ she suggested gently. ‘I’m sure you can.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Bloody hell,’ he muttered, and rubbed his jaw. ‘Daisy and I have made no commitments whatsoever, Miss Kelso,’ he added. ‘So if you’re imagining I’ve led her up the garden path, you’re wrong,’ he finished flatly, then frowned. ‘Isn’t she your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("older")]), _vm._v(" sister?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Daisy is twenty-nine going on nineteen. I’m twenty-six. What you may not understand, Mr Jordan, and I can’t blame you for this, is…’ Lydia paused and wondered how best to explain.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do go on, I’m agog,’ he murmured with considerable irony.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘OK. Our father is a poet. Our mother, a pianist, died when we were little and we were raised by an aunt. She’s my father’s sister and she’s a sculptress—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘An artistic family,’ Joe Jordan commented, looking only one step away from utter boredom as he doodled desultorily. ‘Daisy plays the violin—I can’t wait to find out what you do, Miss Lydia Kelso! Wrestle the double bass?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, I’m quite different,’ Lydia said flippantly. ‘I’m a vet.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had the satisfaction of seeing sheer surprise in his hazel eyes. He said slowly, now looking at her rather intently, ‘So? Where does all this lead?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m the only one of the family who is not in the least artistic and happens to have her feet planted squarely on the ground.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you saying your whole family is mad?’ He blinked at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not at all. But I can’t deny they can be quite—eccentric and naive at times, then madly passionate at others, and, well, given in those moments to doing some rash things. Otherwise they’re warm and wonderful and I would kill rather than see them get hurt.’ Lydia folded her hands in her lap and looked at him serenely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What…’ Joe Jordan could have killed himself for the slightly nervous way he said the word ‘…um—rashness has Daisy concocted towards me? I gather that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" the problem?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia smiled at him. ‘At least you’re quick on the uptake, Mr Jordan. I’ll tell you. She’s decided to have your baby, with or without the benefit of wedlock.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("Joe Jordan’s jaw dropped involuntarily, although he ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("snapped it shut immediately. But before he could utter the cynicism he was prompted towards—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ve heard that one before!")]), _vm._v("—Lydia went on.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘At the moment she’s rather in favour of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("out of wedlock")]), _vm._v(", I have to tell you. I think she looks at herself and sees Jodie Foster, Madonna—there are quite a few famous single mums around—and when you’re as devoted to your career as Daisy is, it’s certainly easier if you only have a child to worry about. She also adores kids, and although twenty-nine is not old, she’s not getting any younger.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why me?’ Joe Jordan asked faintly, after a long pause.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia smiled quite warmly at him this time. ‘You should feel complimented. She’s gone into it very seriously, so she tells me, and she feels that you may contribute the brains she—not exactly lacks, but you’re obviously "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" clever.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe Jordan stood up and planted his fists on the desk. ‘I said this before but—bloody hell! So that’s why she suggested going to bed when…’ He let the sentence hang unfinished in the air, and had to suffer Lydia Kelso looking at him with obvious sympathy—something that annoyed him all the more. ‘Are you sure you’re not making all this up?’ he said then, through his teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Quite sure.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What if I did decide to marry her?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’d be only too relieved, Mr Jordan,’ Lydia said sincerely. ‘Provided you love her, of course. She really needs someone to look after her, especially if she has a child, and I can’t always be there. You know, she’d make a wonderful wife.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("‘How can you say that?’ he demanded bitterly. ‘You’ve just led me to believe she’s as mad as a March ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Hare! Something the whole Kelso clan could suffer from, if I’m not mistaken, despite your assertion to the contrary,’ he added pointedly.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Look,’ Lydia responded coolly, ‘it’s not that I approve, necessarily, but it’s a choice a lot of women are making—and not because they’re mad but because they deem it a viable option in today’s society, where women can aspire to having careers and continuing to have them instead of retreating to the kitchen sink once they start a family.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Go on,’ he ordered tersely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shrugged. ‘Some can cope with it, but I don’t think Daisy would be one of them. And, whilst a lot of mistakes you make in the heat of the moment can be corrected, a fatherless child is not one of them.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe Jordan sat down, propped his chin in his hands and considered that this rangy twenty-six-year-old girl knew how to pack her punches. She shot from the hip and was unusually mature, perhaps. ‘You said you didn’t necessarily approve—apart from Daisy. Why not?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I happen to believe a child needs both its parents. Of course it can’t always be helped, as in my own case. And it’s not that being a natural parent makes one automatically a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("perfect")]), _vm._v(" parent. But at least if you have kinship with a child it has to help.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe raised his eyebrows thoughtfully. ‘It so happens I agree with you. Nor would I countenance being used as a stud. Do you happen to know whether Daisy intended to put me in the picture? Or did she plan to disappear out of my life with a little bundle of joy I was never to know about?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("‘It’s the one thing that’s causing her a bit of a problem,’ Lydia said gravely. ‘Well, there are two. While she feels she may be in love with you, she can’t be sure ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("that you are with her. If you were, then I’m sure she’d abandon all this nonsense.’")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m speechless,’ Joe Jordan remarked with considerable feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Would you like to tell me exactly what you do feel for Daisy?’ Lydia suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No! That is,’ he corrected himself irritably and ironically, ‘I have no intention of marrying her. I have to be honest. Or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anyone")]), _vm._v(" at the moment,’ he said moodily. ‘But—look, this has been a light-hearted—I couldn’t even call it an affair. She was the one who…dammit!’ He glared at Lydia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well, now you know why. But you must have liked her? Or do you pop into bed with every woman who indicates they’re willing?’ She eyed him innocently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He swore, seriously this time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia waited, looking absolutely unruffled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gritted his teeth. ‘I like her. She’s fun to be with, she’s extremely decorative, but…’ He groped for the right words, then sighed savagely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You don’t miss her when she’s not there?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He narrowed his eyes. ‘Is that a true test? You sound as if you…know what you’re talking about.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I got married when I was twenty,’ Lydia said quietly. ‘We had a year together before he was drowned in a boating accident. That’s how it happened for me. He was always on my mind. Tucked into the background at times, yes, but always there.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe Jordan swallowed visibly and looked discomforted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia went on before he could formulate any words. ‘Please don’t feel you need to apologise for anything you may have implied. Nor did I tell you to make you uncomfortable—’")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then why?’ he interrupted. ‘And how come you use your maiden name?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia stood up. ‘My husband’s name was also Kelso, although we were not related at all. It was one of those strange coincidences because it’s not very common. As to why I told you—it was to establish my credibility, I guess. This is not sour grapes, and I do have some experience in these matters.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So what do you suggest I do?’ He lay back and eyed her narrowly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ll leave that up to you, Mr Jordan. But if you do what I think you intend to—let her down lightly, please.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I gather you’ll be there to pick up any pieces?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia hesitated briefly. ‘I’m just about to start a position on a cattle station. It’s only temporary—I’m filling in for a friend while he takes leave—so, no. However, my father and my aunt are in residence at present. Now, my father,’ she said, with a faint smile touching her mouth, ‘may not be quite as civilised as I’ve been should Daisy be inconsolable.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe Jordan stood up with disbelief written in every line of his face. ‘Is that a threat?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, I don’t think he’d do you any bodily harm. But he might come and harangue you, that kind of thing.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t believe this!’ He thumped his fist on the desk, then doubled up in pain clutching his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia blinked, then moved around the desk with her boyish stride. ‘Can I help?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, you can’t! I’m a human being. Why would I need a bloody vet?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Of course it was surprise, he figured out, that had allowed him to be overpowered by a woman. Mind you, he told himself, she was quite strong, even unusually strong, because he’d ended up back in his chair with her ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("long, capable hands massaging and gently manipulating his neck and shoulder in a way that brought him almost instant relief.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘How did it happen?’ she asked conversationally.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He sighed. ‘I was playing tennis and pulled a muscle. Just takes time, so they say. How…you did tell me you were a vet, didn’t you?’ he enquired bitterly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia laughed down into his upturned face. ‘Animals also have muscles, tendons and nerves. I specialise in horses and I’ve done quite a lot of work with racehorses and polo ponies; they often pull muscles. There. What you need is regular physiotherapy, probably.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She moved round to stand in front of him and held out her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Joe Jordan didn’t take it immediately for the very good reason that he was suddenly struck by the insane desire to see this girl without her clothes. To unbutton her mannish jacket and watch the pinstriped trousers sink to the floor, to find out how her figure was curved and how she could be strong yet so slim, to watch that fascinating stride…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Goodbye, Mr Jordan,’ she said gravely. ‘I feel we understand each other quite well, don’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you can understand going from one sister to the other. If you have any idea how enigmatic you appear, Lydia Kelso. If you can understand that you’ve successfully made me feel like a piece of horseflesh…")]), _vm._v(" He bit his lip on all that was hovering on the tip of his tongue and said instead, ‘I guess so. Goodbye, Miss Kelso. You have magic hands, by the way.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So I’m told. Oh!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He followed her dark blue gaze to see it resting on his sketchpad. ‘Ah, I apologise,’ he murmured. ‘I do these things without thinking sometimes.’")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Lydia was laughing down at the cartoon of herself, immensely tall and obviously haranguing a diminutive, seated Joe Jordan in short pants, whose feet didn’t even touch the ground. ‘It’s so good,’ she said, still chuckling appreciatively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s not meant to make "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" laugh,’ he replied with dignity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then I must have an odd sense of humour! May I have it?’ She paused, then added blithely, ‘I can use it to warn myself against being too dictatorial and overpowering, even bossy.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You don’t believe that for one moment, do you?’ he countered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She laughed again. ‘How could you tell?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He paused. ‘I just have the feeling you…’ He hesitated, and wondered what use it was to ponder any further about Daisy Kelso’s surprising sister. ‘Oh, well, it doesn’t matter, I guess.’ But as he stood up he was curiously relieved to discover he was an inch taller than she was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No. It doesn’t,’ she agreed, with an oddly significant little glance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook her hand, then tore the drawing off the pad and gave it to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ll get it framed—don’t bother to come down; I’ll let myself out,’ she murmured, with a look of delicious mischief in her eyes now. And she went round the desk, slung her navy bag on her shoulder and strode out.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("She was still chuckling as she walked along the street in Balmain where Joe Jordan had his townhouse. It was a lovely afternoon and, since its revival in the 1960s, Balmain was a pleasant spot.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("One of Sydney’s oldest suburbs, on a peninsula into ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("the harbour with a few miles of coastline, its fortunes had been varied. But although there were plenty of interesting and historic buildings from its early times of affluence, it now had a trendy population, and she wouldn’t mind a townhouse there herself, she thought, as she waited for the ferry to take her across the harbour. Especially one as nicely restored as Joe Jordan’s.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But then, he could be described as trendy himself, she mused, which she was not, particularly, yet he wasn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quite")]), _vm._v(" what she’d expected…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ferry came and she stepped aboard and turned to have a last look not only at Balmain but at the home suburb of, yes, she had to admit it, a slightly intriguing man.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("That evening, as she was putting the finishing touches to her packing, Daisy wandered into her room and sat down at the dressing table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m going to miss you, Lyd,’ she said as she unpinned the glorious fall of her dark hair and started to brush it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Me too.’ Lydia sat down on the bed and eyed her sister’s back. ‘But you’ll have plenty to occupy yourself, what with the Musica Viva tour and the start of the symphony season.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy sighed and lowered her hand. ‘Can’t seem to get excited about it, somehow.’ She swung round on the stool. ‘It’s my biological clock,’ she added. ‘I can feel it ticking away madly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It actually ticks?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy pulled a face. ‘You know what I mean. I just wish,’ she said intensely, ‘you could meet Joe and give me your opinion. Then I’d know whether to go ahead or not.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Lydia experienced an inner tremor of guilt, but she ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("said easily, ‘There’s an old saying—when in doubt, do nowt. To be honest, Daisy, I think you should put up with your biological clock a bit longer and wait for the right man to come along.’")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So you’ve said. But you’re not twenty-nine—I’ll be thirty in two months!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Maybe you’re confusing the dreaded thirty—remember when we used to think anyone over thirty was ancient?—with the biological clock?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy smiled briefly. ‘I just keep thinking my life is slipping away from me, and that there may not be a Mr Right out there for me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So Joe,’ Lydia said carefully, ‘is not necessarily Mr Right?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Joe’s lovely, most of the time. He can also be moody and sarcastic, and there are times when I don’t think he knows I exist.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia smoothed a pair of khaki shorts across her lap as she wondered how to ask her sister whether she’d actually slept with Joe Jordan. This was one point Daisy had been reticent about, but then she was always reticent, if not to say capable of closing up like a clam, with her family on this touchy subject, because they, above all, knew how frequently she fell in and out of love. But would Joe Jordan squire around a beautiful woman he was not sleeping with? A woman who had indicated her willingness on their first date? She doubted it deeply, Lydia decided.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She asked cautiously instead, ‘Would you say you’re having an affair with him, Daisy?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("‘Not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exactly")]), _vm._v(". I mean, when I decided I wanted him for the father of my child, I made most of the running, you could say. Then I thought—Hey, this guy is also something else; he can give you goosebumps just by ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("looking at you, let alone the rest of it, so…’ She paused with an uplifted expression on her face that Lydia felt answered her question better than words might. ‘So,’ Daisy went on, ‘then I thought, Perhaps I should hang on to him but, put simply, Lyd, he’s not that easy to hang on to.’")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy’s eyes were a true violet. She wasn’t tall, she had a perfect oval face, a lovely figure, she was exquisitely groomed, even for a dinner at home, and she looked every inch a sophisticated twenty-nine-year-old. Nor did her just uttered sentiments belie this—unless you knew her well enough to know that of the two of them she was the much more naive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Does he have other women?’ Lydia asked, packing her shorts and reaching for a blouse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t think so. But the fact of the matter is he hasn’t had much of me lately. He’s losing interest, I would say.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thank heavens, Lydia thought. She said bracingly, ‘Then he’s not worth it, Daisy. Besides, you could end up with a moody kid!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘All the same, there’s something about him—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Listen, Daisy.’ Lydia was suddenly serious. ‘I went along with this when I thought you were theorizing as opposed to actually doing it, because you’re a lot like Dad. Once he gets an idea into his mind nothing can change it until he gets it out of his system.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thank you,’ Daisy said gravely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But now it’s time for straight talking,’ Lydia went on pointedly. ‘If you love Joe Jordan and he loves you and wants to marry you, you have my blessing. Otherwise it’s a dangerous game you’re playing—don’t do this to yourself. You’re worth much more than a life of seducing men so you can have a baby.’")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy turned the brush over in her hands. ‘You don’t know what it’s like, Lyd,’ she said slowly. ‘You fell in love once and it worked out perfectly—well, until Brad died, of course. But it never works perfectly for me.’ She brushed away a tear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Could you be…could you be a shade too generous, Daisy?’ Lydia suggested, picking her words with care. ‘Why don’t you play hard to get for a change?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy lifted her head as if struck by inspiration. ‘Oh. Maybe Joe would respond to that!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Forget Joe Jordan—’ Lydia broke off and bit her lip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Uh—you told me yourself that he’s very clever and that he can be moody and sarcastic. That’s always hard to live with unless you’re clever in the same way. What you need is someone musical, someone who could share the area where you’re really sensitive and creative.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy stared reflectively into the distance. ‘There is a new oboe player who’s just joined the orchestra. He’s rather sweet, and I can tell he’s interested, but, no, it wouldn’t work.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s probably far too early to tell whether it would work,’ Lydia commented practically, ‘but how can you be so sure it wouldn’t?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He’s younger.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Younger… How much?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He’s about your age, I guess.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia was struck silent for a long moment, struck by the irony of her sister plotting to have some man’s child to bring up on her own yet unable to contemplate a normal relationship with a man because he was a little younger…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She said, at length, ‘Three years—that’s nothing, really.’")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, yes, it is. When I’m thirty he’ll still be in his twenties. More importantly, when I’m fifty, he’ll still be in his forties. I’m sure it should be the other way around because men tend to age better than women, don’t you think?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Lydia was suddenly gripped by the feeling that a younger man could be just what Daisy needed. Might it not bring out a so far latent streak of maturity in her? As well as getting her over Joe Jordan, of course. Then she sighed and decided she’d done enough interfering in her sister’s life for one day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why don’t you just wait and see what happens?’ she murmured, and reached for the silver-framed photo of Brad on the dressing table. She stared down at it, blinked a couple of times, then laid it gently face down on top of her clothes in the suitcase.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy was on her feet in a flash, and she knelt in front of Lydia and took her hands. ‘Do you still miss him so much, darling? I had hoped it was getting easier.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It is, mostly,’ Lydia said tremulously. ‘Just sometimes it’s actually harder. I don’t know why. Unless it’s because I’m afraid I’ll forget.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You know,’ her sister said, ‘you worry an awful lot about me, but I can tell you that Brad loved you so much he would not want you to be unhappy for ever. And it’s been five years now. Time to stop living a half-life. Time to have no guilt about finding someone else.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia smiled painfully. ‘The problem is, I couldn’t care less if I never did find anyone else. Men don’t seem to interest me much, apart from—’ She stopped abruptly as it surfaced in her mind that Joe Jordan was the first interesting man she’d met for a long time. To make matters worse, she’d been just about to say it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So there is someone?’ Daisy said eagerly.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No!’ Lydia denied hastily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But you said—“apart from…”?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Um—the ones you can’t have,’ Lydia improvised madly, then thought, Well, that wasn’t so far from the truth either.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Still, that could be a start!’ Daisy frowned. ‘Anyone I know?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No. No—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is he married?’ Daisy asked, with both understanding and sympathy. ‘A lot of the best ones are.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You’re right—was that Chattie calling?’ Their aunt Charlotte was universally known as Chattie Kelso, and she still lived with them in the big old house at Bronte, a beachside suburb of Sydney where both Daisy and Lydia had grown up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy rose. ‘She’s cooked roast pork,’ she said conspiratorially. ‘You know how paranoid she is about getting the crackling crisp. We’d better not keep her waiting.’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("James Kelso, who was renowned for his bush ballads and poetry written under the name of Kelso James, as well as renowned for always wearing a bush shirt and jeans, raised his glass and cleared his throat. ‘I’d like to propose several toasts. First to you, my dear Chattie, for the crispest crackling you’ve ever produced.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chattie, a spinster in her fifties, with Lydia’s colouring and build although her hair was sprinkled with grey now, looked gratified. She raised her glass in return and her fine eyes glinted with mischief. ‘Thought so myself, although I didn’t like to say it.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("‘And to you, my dear Daisy—’ James inclined his head towards his elder daughter ‘—for looking sensa")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("tional, as usual. No one would think you were a day over nineteen.’")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daisy smiled fondly at him. ‘Dad, you’re sweet, but you tell awful lies!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘May one enquire how your love life is going at present?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘One may—it’s going, but it’s at a critical stage, you could say.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Hmm. Dangerous age, twenty-nine. Would you agree, Chattie?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No. They can all be dangerous. I consider myself at my most dangerous when I was seventeen, closely followed by thirty-nine. At seventeen I would have done anything to have a boyfriend and be like the rest of the girls, and at thirty-nine I would have done anything to have a husband.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What about children?’ Daisy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That too. I gave serious thought to having one without a husband—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Chattie!’ James reproved. ‘Don’t put silly ideas into their young heads.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia ate her roast pork and thought that if Joe Jordan were a fly on the wall he might be able to judge for himself how eccentric her family could be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If you’d let me finish,’ Chattie said, ‘I decided against it because I realised it was extremely unfair to a child to deprive it of a father.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia put her knife and fork down and glanced at her aunt through her lashes. Had a whiff of Daisy’s state of mind got through to her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have to agree,’ James said. ‘For example, do you or do you not think I’ve enriched your lives, girls?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Daisy masked her expression almost immediately, but Lydia saw her sheer horror at the thought of never hav")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("ing known their father, and she felt like cheering at the same time as she wondered whether her father had also divined Daisy’s dilemma…")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She said, ‘Dad, you’ve not only enriched our lives but your wisdom never ceases to amaze me—when you’re not driving me mad with your forgetfulness, your inability to find your glasses, even when they’re on top of your head, and the way you persistently wear odd socks—when you remember to wear them at all.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well, that brings me to you, Lydia, my younger and most practical daughter,’ James said humorously. ‘We’re going to miss you, my dear. Who else will we have to fix fuses and start our cars when they break down? You know how hopeless I am at that kind of thing.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I do.’ Lydia grinned. ‘Heaven alone knows where that expertise came down to me from, but if you just look in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yellow Pages")]), _vm._v(" you’ll find there are electricians, mechanics, plumbers and so on galore—on second thoughts, I’d better write you out a list.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Now that makes us feel really small,’ James Kelso admonished, ‘but I’d be much easier if you did! And I know I speak for the rest of us when I say we’re all happy to think of you enjoying a new challenge, a new experience—may it be a wonderful one!’ He raised his glass again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Hear, hear!’ Chattie and Daisy echoed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So let’s think up a suitable limerick,’ James went on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a game they’d played ever since Lydia could remember…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Lydia Kelso is going to Queensland,’")]), _vm._v(" Daisy started.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘To…look after cows…with a magic hand,’")]), _vm._v(" Chattie supplied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Not for too long,’")]), _vm._v(" James said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘You won’t know I’m gone!’")]), _vm._v(" Lydia laughed.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was silence until Daisy said frustratedly, ‘The last line is always the hardest! What rhymes with Queensland? We’ve got hand…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Wedding band?’ Chattie suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, no!’ Lydia protested. ‘There’s not the least likelihood of that happening, and anyway, I didn’t like to interrupt the creative flow, but I’m actually going to the Northern Territory.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Everyone groaned. ‘Oh, well,’ James murmured, ‘that’s right next door, so we won’t start again—and you never know! So… "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("And she’ll come home complete with a wedding band.")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Very amateurish,’ Lydia said. ‘But thank you all for your good wishes!’ And she looked round the dining room, with its heavy old oak table, dark green walls, examples of her aunt’s sculpting and some lovely gold-framed paintings on the wall. ‘I’ll miss you,’ she added. ‘Just promise me you’ll all be good!’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("It struck her as she got ready for bed that she could go away with a much easier mind, now. A quiet word with Chattie had revealed that she was aware of Daisy’s dilemma and would keep a weather eye out for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We won’t tell your father,’ she’d said. ‘He’s liable to go and want to have things out with this Joe Jordan.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia had confessed that she’d already done that, but that Daisy was unaware of her actions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What’s he like?’ Chattie had asked curiously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Interesting, but not serious about her—nor, I suspect, did he stand much chance. She made the running, so to speak.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So she is sleeping with him?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She hasn’t actually admitted to that, but she looks, well, you know…’")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I do. But he could have knocked her back. How like a man!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They’d looked at each other, then grinned simultaneously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Daisy, in full flight, is a sight to behold,’ Chattie had acknowledged. ‘Perhaps I was being a bit hard on him. What about you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia had blinked. ‘What about me?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘When are you going to lay Brad to rest and start living again?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not you too!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Your father been giving you a hard time?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia had shaken her head. ‘Daisy. But I am living, and enjoying myself and really looking forward to this job!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘All right.’ Chattie had looked as if she’d been about to say more, but had desisted and hugged her niece instead. ‘Leave them to me; I’ll look after them!’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Lydia took off her pinstriped trouser suit, donned a velvet housecoat and sat down at her dressing table to brush her hair, after removing a few very dark strands from the brush.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d returned to this room and this single bed after a year of marriage, and some days it was hard to believe she’d ever left it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She and Brad had met at university, he’d been studying economics, and the first thing to draw them together had been their common although unusual surname. But the attraction had been almost instantaneous, and mutual. It had also been a revelation to Lydia, because he’d been her first serious boyfriend, and to find someone she clicked with so completely had been totally unexpected.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("To fall so much in love when she’d expected to spend ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("her university years working hard to achieve her career goals had also been disconcerting, but that had been another wonderful part of their relationship. They’d been quite happy to allow each other the space to study.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So, after two years, and before she had graduated—although he had, and had joined an eminent firm of stockbrokers—they’d got married, got themselves a small flat and had a year of idyllic happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had been a matter of surprise to many, her family included, that she should have been the first sister to marry, and so young.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d been such fun, she thought sadly, the night before she went—not to Queensland, although via it to the Northern Territory. Not that you’d necessarily have known that behind his glasses and his computer-like brain there had lurked a delicious sense of humour. And he’d handled her growing ardour with surprising passion for a man who had always been able to tell you how many points the All Ordinaries or the Dow Jones had gained or dropped overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t fair. She’d thought it so many times, when her body had ached physically for him, and her mind had yearned for the warmth, tenderness and laughter they’d generated together.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d also suffered the growing conviction it would never happen for her that way again. So that, despite their good intentions, she hated it when people told her it was time to think of falling in love again—even her own sister.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She brushed steadily for a few minutes, trying to compose herself, and finally found some relief from her sad thoughts coming from an unusual direction…Joe Jordan and his hints that she was not as feminine as her gorgeous sister.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She put the brush down and studied herself in the mirror. What would he have thought, she mused, if he’d known that under her suit she’d been wearing—these?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘These’, beneath her velvet robe, were a midnight-blue silk camisole deeply edged with lace and a matching pair of panties.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stood up, opened her robe and, putting her hands on her hips, twirled slowly in front of the mirror. True, she conceded to her image, she was not like Daisy, who had an hourglass figure, but—how had Brad put it? Beneath her clothes she was slim, sleek and surprisingly sensuous, and her legs were to die for.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, she told herself as she sat down again and grinned at herself, what appeals to one man may not appeal to another! And although her clothes were sometimes mannish it was only for comfort, and they were beautifully made. She also had a passion for shoes and bags and the finest lingerie.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So there, Mr Jordan, she thought, and was tempted to stick out her tongue at a mental image of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then she sobered and wondered what on earth she was thinking. Only minutes ago she’d been consumed by sadness and the unfairness of fate—how could she be thinking of another man? A man her sister might be in love with—might even have slept with, moreover.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She closed her eyes and clenched her hands until Brad came back to her in her mind, and she remembered how he’d loved to cook, but had been quite hopeless at clearing up after himself…")])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page27"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26433332","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459204607_ch01.vue
// module id = 69
// module chunks = 0